/**
 * Centralized API Configuration
 * Single source of truth for all API URLs and configuration
 */

// Base API URL - uses environment variable with fallback
// Remove trailing slash if present to prevent double slashes in URLs
const rawApiUrl = process.env.REACT_APP_API_BASE_URL || 'https://clinica-server.replit.app';
export const API_BASE_URL = rawApiUrl.endsWith('/') ? rawApiUrl.slice(0, -1) : rawApiUrl;

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: `${API_BASE_URL}/auth`,
    LOGOUT: `${API_BASE_URL}/auth/logout`,
    REGISTER: `${API_BASE_URL}/auth/register`,
    PASSWORD_CHANGE: `${API_BASE_URL}/password-change`,
    FORGOT_PASSWORD: `${API_BASE_URL}/forgot-password`,
  },
  
  // User endpoints
  USERS: {
    LIST: `${API_BASE_URL}/users`,
    BY_ID: (id) => `${API_BASE_URL}/users/${id}`,
    DELETE: (id) => `${API_BASE_URL}/delete-user/${id}`,
  },
  
  // Data endpoints
  DATA: {
    STATS: `${API_BASE_URL}/datastats`,
    FILTER: `${API_BASE_URL}/filter`,
    HCP: `${API_BASE_URL}/hcp`,
    PAYER: `${API_BASE_URL}/payer`,
    HOSPITAL: `${API_BASE_URL}/hospital`,
  },
  
  // Contact
  CONTACT: `${API_BASE_URL}/send-email`,
};

// Helper function to construct full URL
export const getApiUrl = (path) => `${API_BASE_URL}${path}`;

export default API_BASE_URL;
